/* eslint-disable camelcase */
import React from 'react'
import PropTypes from 'prop-types'
import { find } from 'lodash'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import Operations from '../../../../operations'
import CarePlanForm from './CarePlanReviewForm'
import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'

/**
 * Fetch the data required and initialise the form state to render the CarePlanReviewForm
 */
export class CarePlanReviewScreen extends React.Component {
  componentDidMount() {
    const {
      getData,
      router: {
        params: { id, care_plan_id },
      },
    } = this.props

    getData({ carePlanId: care_plan_id, resident: id })

    const careplan = this.getCareplan(this.props)
    if (careplan) {
      this.addForm(careplan)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { editCarePlanFormExists } = nextProps
    const next = this.getCareplan(nextProps)
    if (!editCarePlanFormExists && next) {
      this.addForm(next)
    }
  }

  getCareplan = () => {
    // move to redux
    const {
      carePlans,
      router: {
        params: { care_plan_id },
      },
    } = this.props
    return find(carePlans, { id: care_plan_id })
  }

  addForm = (careplan) => {
    const { addForm } = this.props
    if (careplan.nextReviewDate) careplan.nextReviewDate = null
    addForm(careplan)
  }

  render() {
    const {
      router: { params },
    } = this.props
    const careplan = this.getCareplan()
    if (!careplan) return null
    return <CarePlanForm router={history} params={params} />
  }
}

CarePlanReviewScreen.propTypes = {
  addForm: PropTypes.func.isRequired,
  carePlans: PropTypes.array,
  editCarePlanFormExists: PropTypes.bool,
  getData: PropTypes.func.isRequired,
  router: PropTypes.object,
}

const mapStateToProps = (state) => ({
  riskAssements: state.data['risk-assessments'],
  editCarePlanFormExists: !!state.forms.editCarePlan,
  carePlans: state.data['care-plans'],
})

const mapDispatchToProps = (dispatch) => ({
  getData: ({ resident, carePlanId }) => {
    dispatch(Operations.loadListItem('care-plans', carePlanId))
    dispatch(
      Operations.loadList('risk-assessments', {
        carePlan: carePlanId,
        withFormData: true,
      })
    )
    dispatch(Operations.loadList('logs', { carePlanId }))
    dispatch(Operations.loadList('documents', { carePlanId, resident }))
  },
  addForm: (initial) =>
    dispatch(
      Actions.addForm({
        formId: 'editCarePlan',
        initial,
      })
    ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CarePlanReviewScreen))
